export interface GetDailyReportListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetDailyReportListPagingAndFilterResponseData
}

export interface GetDailyReportListPagingAndFilterResponseData {
    items: GetDailyReportListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetDailyReportListPagingAndFilterResponseItem {
    deviceId: string
    deviceNo: string
    vehicleTypeId: string
    vehicleTypeName: string
    vehicleTypeImage: string
    plate: string
    ioStatus: boolean
    ioStatusStr: string
    directionDegree: number
    kmPerHour: number
    gpsDateTime: string
    latitude: number
    longitude: number
    location: string
    createdDate: string
    createdUser: string
    updatedDate: any
    updatedUser: any
    status: string
    statusColor: string
    totalKmDaily: number
    isIdle: boolean
    currentKm: number
    statusReal: any
    statusColorReal: any
}

export const initialGetDailyReportListPagingAndFilterResponseData: GetDailyReportListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}